import BaseAPI from '../base'

function getOnetimeCode() {
    return BaseAPI.get(`ownersbot/onetimecode`);
}

function getDepositForm(key) {
    return BaseAPI.get(`ownersbot/deposit_form/${key}`);
}

export default {
    getOnetimeCode,
    getDepositForm
}